import React from 'react';
import classNames from 'classnames';

import './manage-stop-control-menu.scss';

function ManageStopControlMenu({ children, className }) {
    function _getClassName() {
        const defaultClassName = `managestopcontrol_menu _fd-column`;
        return classNames(defaultClassName, className);
    }
    return <div className={_getClassName()}>{children}</div>;
}

export { ManageStopControlMenu };
